import { render, staticRenderFns } from "./AppCommonMenu.vue?vue&type=template&id=3782c9d4&scoped=true&"
import script from "./AppCommonMenu.vue?vue&type=script&lang=js&"
export * from "./AppCommonMenu.vue?vue&type=script&lang=js&"
import style0 from "./AppCommonMenu.vue?vue&type=style&index=0&id=3782c9d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3782c9d4",
  null
  
)

export default component.exports